module.exports = __webpack_public_path__ + "static/media/fb-clone.649d14c7.png";